import { type Component, createMemo, createSignal, mergeProps } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import Button from '~/components/Button'
import Icon from '~/components/Icon'
import type { UpdateBannerPropsType } from '~/types/UpdateBanner'

const UpdateBanner: Component<UpdateBannerPropsType> = props => {
  const merged = mergeProps(
    {
      message: 'Hay una nueva versión disponible.',
      updateLabel: 'Actualizar'
    },
    props
  )

  const [updating, setUpdating] = createSignal(false)

  // El banner siempre visible mientras el padre lo muestre (Show when={needRefresh()})
  const isUpdating = createMemo(() => updating())

  const handleUpdate = () => {
    setUpdating(true)
    merged.onUpdate()
  }

  return (
    <div role="status" aria-live="polite" aria-atomic="true" class={twMerge('fixed bottom-0 left-0 right-0 z-9999', 'animate-slide-up')}>
      <div class="bg-inverse border-t border-border shadow-[0_-4px_24px_rgba(0,0,0,0.25)]">
        <div class="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center gap-3 flex-wrap sm:flex-nowrap">
          {/* Icono */}
          <div class="shrink-0 h-9 w-9 rounded-full bg-primary-500/15 flex items-center justify-center">
            <Icon icon="material-symbols-light:refresh" size={20} class="text-primary" />
          </div>

          {/* Mensaje */}
          <p class="flex-1 text-sm text-on-inverse min-w-0">{merged.message}</p>

          {/* Botón actualizar */}
          <div class="shrink-0">
            <Button
              variant="contained"
              color="primary"
              size="sm"
              loading={isUpdating()}
              startIcon="material-symbols-light:refresh"
              onClick={handleUpdate}
              aria-label="Instalar nueva versión y recargar"
              disabled={isUpdating()}
            >
              {merged.updateLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateBanner
